import { useFlowControlSimulationCueStore } from '@/state/stores/use-flow-control-simulation-cue-store';
import type { FlowControlSegmentKind } from '@/helpers/simulation-cue-engine.helper';
import { computeFlowControlSegmentActive } from './flow-control-segment-status.compute';
import { useFlowControlSegmentLiveContext } from './use-flow-control-segment-live-context';
import type { SlotSegmentAnchor } from './slot-right-section-play-icon';

/** Whether a Control tab segment row is currently playing (live or simulation). */
export function useFlowControlSegmentActive(
  segmentAnchor: SlotSegmentAnchor,
  segmentKind?: FlowControlSegmentKind,
  slotId?: string,
  override?: boolean,
): boolean {
  const { isSimulation, cueState } = useFlowControlSegmentLiveContext();

  const simulationRows = useFlowControlSimulationCueStore((s) => s.rows);
  const simulationPointer = useFlowControlSimulationCueStore((s) => s.pointer);
  const simulationSelectedItemIds = useFlowControlSimulationCueStore((s) => s.selectedItemIds);
  const simulationActiveSegmentKind = useFlowControlSimulationCueStore((s) => s.activeSegmentKind);
  const simulationActiveSegmentSlotId = useFlowControlSimulationCueStore((s) => s.activeSegmentSlotId);

  return computeFlowControlSegmentActive(segmentAnchor, segmentKind, slotId, {
    override,
    isSimulation,
    cueState,
    simulation: {
      rows: simulationRows,
      pointer: simulationPointer,
      selectedItemIds: simulationSelectedItemIds,
      activeSegmentKind: simulationActiveSegmentKind,
      activeSegmentSlotId: simulationActiveSegmentSlotId,
    },
  });
}
